var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupportPk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 116,
    viewBox: "0 0 100 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1259"
  }, /*#__PURE__*/React.createElement("path", {
    id: "K",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.6963 0.0429688C57.1962 0.174544 61.4826 1.25639 65.7983 2.52828H65.7954V85.877C61.9797 89.7102 57.6143 92.8095 52.6963 95.4586V0.0429688ZM99.3709 17.1882L99.3738 17.1896L99.3709 17.1867C99.3709 17.1872 99.3709 17.1877 99.3709 17.1882ZM99.3709 17.1882L98.6696 16.8548C94.4561 14.8517 90.3297 12.8899 86.0643 10.8652C86.0321 14.6905 86.0424 18.4736 86.0526 22.2284C86.0703 28.7111 86.0877 35.1091 85.8859 41.4931C82.8472 43.2509 79.8538 44.9817 76.8553 46.7155C74.3574 48.1598 71.856 49.6061 69.322 51.0718C72.4688 52.8919 75.5442 54.6718 78.6024 56.4417C80.4175 57.4923 82.2266 58.5393 84.0409 59.5891C80.9767 79.1354 70.2284 92.8046 52.6704 101.325V115.979C80.7398 104.655 94.9003 85.144 97.8973 55.6243L97.0691 55.1433C94.7871 53.818 92.4782 52.4772 90.0554 51.0689C92.3247 49.7519 94.4814 48.4994 96.6197 47.2575C97.3632 46.8257 98.1045 46.3952 98.8475 45.9637C99.4206 36.3329 99.4557 26.7577 99.3709 17.1882Z",
    fill: "#38A6D5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P",
    d: "M16.0514 60.1241C26.1974 55.3611 36.1766 50.525 47.3167 48.9724V0C44.2027 0.10526 41.2525 0.678345 38.3286 1.39178C29.3903 3.573 21.0922 7.40624 12.8381 11.3477C8.77093 13.2862 4.70379 15.2335 0.619099 17.1867C0.619099 22.5725 0.557697 27.8794 0.630795 33.1863C0.774066 43.4638 1.31791 53.715 3.25938 63.8404C5.25933 74.2875 8.81771 84.0826 15.2766 92.6701C22.3846 102.123 31.744 108.705 42.2613 113.798C43.9016 114.593 45.5214 115.456 47.3489 116V101.336C29.9809 92.8981 19.2093 79.4336 16.0514 60.1212V60.1241ZM14.3936 46.259C13.9316 39.2972 13.9111 32.4874 13.9316 25.6367C20.5045 22.4029 27.0073 19.2626 33.9633 16.713V38.3002C27.2617 40.4229 20.8905 43.1684 14.3907 46.259H14.3936Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportPk);
export default __webpack_public_path__ + "static/media/support-pk.abd009524e08dc29b410459585df304d.svg";
export { ForwardRef as ReactComponent };